import React from 'react';
import { useAppContext } from '../context/AppContext';
import gardenBedLayouts from '../data/gardenBedLayouts.json';
import { Table, Text } from '@mantine/core';

const GardenShoppingList = () => {
	const { state } = useAppContext();
	const { bedConfig } = state.currentDesign || {};

	const matchingGardenBed = bedConfig ? gardenBedLayouts.find((layout) => layout.id === bedConfig) : null;
	const mulchAmount = matchingGardenBed ? matchingGardenBed.mulch : 0;
	const plantingMixAmount = matchingGardenBed ? matchingGardenBed.soil : 0;
	const edgingAmount = matchingGardenBed ? matchingGardenBed.edging : 0;

	return (
		<Table striped highlightOnHover withTableBorder withColumnBorders>
			<Table.Thead>
				<Table.Tr>
					<Table.Th>Item</Table.Th>
					<Table.Th>Unit</Table.Th>
					<Table.Th>Quantity</Table.Th>
				</Table.Tr>
			</Table.Thead>
			<Table.Tbody>
				<Table.Tr>
					<Table.Td>
						<Text size="sm">Mulch</Text>
					</Table.Td>
					<Table.Td>
						<Text size="sm">2 C.F. Bags</Text>
					</Table.Td>
					<Table.Td>
						<Text size="sm">{mulchAmount} bags</Text>
					</Table.Td>
				</Table.Tr>
				<Table.Tr>
					<Table.Td>
						<Text size="sm">Planting Mix</Text>
					</Table.Td>
					<Table.Td>
						<Text size="sm">2 C.F. Bags</Text>
					</Table.Td>
					<Table.Td>
						<Text size="sm">{plantingMixAmount} bags</Text>
					</Table.Td>
				</Table.Tr>
				<Table.Tr>
					<Table.Td>
						<Text size="sm">Edging</Text>
					</Table.Td>
					<Table.Td>
						<Text size="sm">Linear Feet</Text>
					</Table.Td>
					<Table.Td>
						<Text size="sm">{edgingAmount} feet</Text>
					</Table.Td>
				</Table.Tr>
			</Table.Tbody>
		</Table>
	);
};

export default GardenShoppingList;
